import { render, staticRenderFns } from "./ViewScopingTitlePagePeople.vue?vue&type=template&id=53ee15f8"
import script from "./ViewScopingTitlePagePeople.vue?vue&type=script&lang=js"
export * from "./ViewScopingTitlePagePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports